import { Link, NavLink } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Wordmark } from "./Logo";
import { LangSwitch } from "./LangSwitch";
import { useT } from "@/lib/i18n";

const TXT = {
  no: { back: "Forside", links: [["/chiptuning", "Chiptuning"], ["/bilnokler", "Bilnøkler"], ["/priser", "Priser"]] },
  en: { back: "Home", links: [["/chiptuning", "Chiptuning"], ["/bilnokler", "Car keys"], ["/priser", "Prices"]] },
};

const cls = ({ isActive }) =>
  `whitespace-nowrap font-mono text-xs uppercase tracking-[0.2em] transition-colors hover:text-white ${isActive ? "text-white underline decoration-[var(--red)] underline-offset-[6px]" : "text-zinc-300"}`;

// Header for the standalone subpages (/priser, /chiptuning, /bilnokler).
export const SubHeader = () => {
  const t = useT(TXT);
  return (
    <header className="border-b border-white/10" data-testid="sub-header">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between gap-4 px-5 sm:px-8">
        <Link to="/" data-testid="sub-header-home-link"><Wordmark /></Link>
        <div className="flex items-center gap-4 sm:gap-6">
          <nav className="hidden items-center gap-6 md:flex">
            {t.links.map(([to, label]) => <NavLink key={to} to={to} className={cls} data-testid={`sub-nav-${to.slice(1)}`}>{label}</NavLink>)}
          </nav>
          <Link to="/" className="flex items-center gap-2 font-mono text-xs uppercase tracking-widest text-zinc-300 hover:text-white" data-testid="sub-header-back-link">
            <ArrowLeft size={14} /> {t.back}
          </Link>
          <LangSwitch testid="sub-header-lang-switch" />
        </div>
      </div>
      <nav className="flex gap-6 overflow-x-auto border-t border-white/5 px-5 py-3 md:hidden">
        {t.links.map(([to, label]) => <NavLink key={to} to={to} className={cls} data-testid={`sub-nav-mobile-${to.slice(1)}`}>{label}</NavLink>)}
      </nav>
    </header>
  );
};
